<!-- eslint-disable vue/no-template-shadow -->
<template>
  <div v-if="!isLoading">
    <v-card-text>
      <v-row>
        <v-spacer></v-spacer>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="itemsPerPage"
            :label="$t('lbl.itemsPerPage')"
            type="number"
            min="5"
            hide-details
            dense
            outlined
            @input="changeCantItems()"
          ></v-text-field>
        </v-col>

        <!--<v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="search"
            :append-icon="icons.mdiMagnify"
            :label="$t('btn.search')"
            single-line
            hide-details
            dense
            outlined
            @input="getCuentasXCobrar()"
          ></v-text-field>
        </v-col>-->
      </v-row>
    </v-card-text>

    <v-divider></v-divider>
    <v-form class="multi-col-validation px-5 py-5">
      <v-row>
        <v-col
          v-if="pos === 0"
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.from') }}</strong>
          <v-menu
            v-model="menuFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedFromDateFormatted"
                :label="$t('lbl.date')"
                persistent-hint
                class="pt-2"
                readonly
                v-bind="attrs"
                outlined
                dense
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="search.from"
              no-title
              locale="es"
              :show-current="false"
              @input="menuFrom = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          v-if="pos === 0"
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.to') }}</strong>
          <v-menu
            v-model="menuTo"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedToDateFormatted"
                :label="$t('lbl.date')"
                persistent-hint
                class="pt-2"
                readonly
                v-bind="attrs"
                outlined
                dense
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="search.to"
              :min="
                search.from
                  ? $moment(search.from)
                    .add(1, 'day')
                    .toDate()
                    .toISOString()
                    .substr(0, 10)
                  : ''
              "
              no-title
              locale="es"
              :show-current="false"
              @input="menuTo = false"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col
          v-if="pos === 0"
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.modality') }}</strong>
          <v-select
            v-model="search.method_pay_id"
            :items="payments"
            :label="$t('lbl.wayMethod')"
            outlined
            dense
            hide-details
            item-text="name"
            item-value="id"
            class="pt-2"
          ></v-select>
        </v-col>
        <v-col
          v-if="pos === 0"
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.proveedor') }}</strong>
          <v-autocomplete
            v-model="search.proveedor_id"
            :items="proveedores"
            :search-input.sync="proveedorSearch"
            hide-details
            hide-selected
            :label="$t('lbl.acredor')"
            outlined
            dense
            item-text="name"
            item-value="id"
            class="pt-2"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('lbl.acredor') }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item }">
              <span v-text="item.name"></span>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col
          v-if="pos === 0"
          cols="12"
          md="4"
        >
          <strong>{{ $t('menu.ctaXP') }}</strong>
          <v-autocomplete
            v-model="search.code"
            :items="codesCtas"
            :search-input.sync="searchCodeCtas"
            hide-details
            hide-selected
            :label="$t('lbl.code')"
            outlined
            dense
            class="pt-2"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('lbl.code') }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item }">
              <span v-text="item"></span>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          v-if="pos === 0"
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.stateAccount') }}</strong>
          <v-select
            v-model="search.status_id"
            :items="statesCtas"
            :label="$t('lbl.state')"
            outlined
            dense
            hide-details
            item-text="name"
            item-value="id"
            class="pt-2"
          ></v-select>
        </v-col>

        <!--PAYS-->
        <v-col
          v-if="pos === 1"
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.code') }}</strong>
          <v-autocomplete
            v-model="search.code"
            :items="codesPays"
            :search-input.sync="searchCodePays"
            hide-details
            hide-selected
            :label="$t('lbl.code')"
            outlined
            dense
            single-line
            class="pt-2"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('lbl.code') }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item }">
              <span v-text="item"></span>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          v-if="pos === 1"
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.emitidoFrom') }}</strong>
          <v-menu
            v-model="menuFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedFromDateFormatted"
                :label="$t('lbl.dateEmitido')"
                persistent-hint
                class="pt-2"
                readonly
                v-bind="attrs"
                outlined
                dense
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="search.from"
              no-title
              locale="es"
              :show-current="false"
              @input="menuFrom = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          v-if="pos === 1"
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.emitidoTo') }}</strong>
          <v-menu
            v-model="menuTo"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedToDateFormatted"
                :label="$t('lbl.dateEmitido')"
                persistent-hint
                class="pt-2"
                readonly
                v-bind="attrs"
                outlined
                dense
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="search.to"
              :min="
                search.from
                  ? $moment(search.from)
                    .add(1, 'day')
                    .toDate()
                    .toISOString()
                    .substr(0, 10)
                  : ''
              "
              no-title
              locale="es"
              :show-current="false"
              @input="menuTo = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          v-if="pos === 1"
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.acredor') }}</strong>
          <v-autocomplete
            v-model="search.acredor"
            :items="acredores"
            :search-input.sync="acredorSearch"
            hide-details
            hide-selected
            :label="$t('lbl.provideService')"
            outlined
            dense
            item-text="user_name"
            item-value="code_unique"
            class="pt-2"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('lbl.provideService') }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item }">
              <span v-text="item.user_name"></span>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.user_name }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          v-if="pos === 1"
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.wayMethod') }}</strong>
          <v-select
            v-model="search.slug_pay"
            :items="wayPays"
            :label="$t('lbl.wayMethod')"
            outlined
            dense
            hide-details
            item-text="name"
            item-value="slug"
            class="pt-2"
          ></v-select>
        </v-col>
        <v-col
          v-if="pos === 1"
          cols="12"
          md="3"
        >
          <strong>{{ $t('register.moneda') }}</strong>
          <v-select
            v-model="search.currency"
            :items="currencies"
            :label="$t('register.moneda')"
            outlined
            dense
            hide-details
            item-text="name"
            item-value="slug"
            class="pt-2"
          ></v-select>
        </v-col>
        <v-col
          v-if="pos === 1"
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.importe') }}</strong>
          <v-autocomplete
            v-model="search.importe"
            :items="importes"
            :search-input.sync="importesSearch"
            hide-details
            hide-selected
            :label="$t('lbl.importePay')"
            outlined
            dense
            class="pt-2"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('lbl.importePay') }}
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          v-if="pos === 1"
          cols="12"
          md="3"
        >
          <strong>{{ $t('lbl.emitidoBy') }}</strong>
          <v-autocomplete
            v-model="search.emitido_by"
            :items="usersEmitidos"
            :search-input.sync="usersEmitidosSearch"
            hide-details
            hide-selected
            :label="$t('lbl.emitidoBy')"
            outlined
            dense
            item-text="name"
            item-value="id"
            class="pt-2"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('lbl.emitidoBy') }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item }">
              <span v-text="item.name"></span>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-form>
    <v-divider></v-divider>
    <v-form class="multi-col-validation px-5 py-5">
      <v-row>
        <v-col
          cols="12"
          md="1"
        >
          <v-btn
            v-if="
              search.from ||
                search.to ||
                search.method_pay_id ||
                search.proveedor_id ||
                search.code ||
                search.status_id ||
                search.acredor ||
                search.slug_pay ||
                search.currency ||
                search.importe ||
                search.emitido_by
            "
            class="mx-2"
            fab
            outlined
            small
            color="error"
            @click="clearSearch()"
          >
            <v-icon small>
              {{ icons.mdiEraserVariant }}
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          md="9"
          class="text-center"
        >
          <v-row>
            <v-col
              cols="12"
              md="2"
              offset-md="2"
            >
              <v-btn
                :loading="loading"
                color="primary"
                @click="searchAll()"
              >
                <v-icon
                  right
                  dark
                >
                  {{ icons.mdiMagnify }}
                </v-icon>
                <span class="pl-5">{{ $t('btn.search') }}</span>
              </v-btn>
            </v-col>
            <v-col
              v-if="pos === 0"
              cols="12"
              md="2"
              offset-md="1"
            >
              <v-btn
                :loading="loadingPay"
                color="primary"
                outlined
                :disabled="itemsCheck.length === 0"
                @click="emitPays()"
              >
                <v-icon
                  right
                  dark
                >
                  {{ icons.mdiAccountCashOutline }}
                </v-icon>
                <span class="pl-5">{{ $t('btn.emitPays') }}</span>
              </v-btn>
            </v-col>

            <fragment v-if="pos === 1">
              <v-col
                cols="12"
                md="2"
                offset-md="1"
              >
                <v-btn
                  :loading="loadingPay"
                  color="primary"
                  outlined
                  :disabled="itemsCheckPaysEmit.length === 0"
                >
                  <v-icon
                    right
                    dark
                  >
                    {{ icons.mdiSendOutline }}
                  </v-icon>
                  <span class="pl-5">{{ $t('btn.sendPays') }}</span>
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                md="2"
                offset-md="1"
              >
                <v-btn
                  :loading="loadingPay"
                  color="primary"
                  outlined
                  :disabled="itemsCheckPaysEmit.length === 0"
                >
                  <v-icon
                    right
                    dark
                  >
                    {{ icons.mdiPrinter }}
                  </v-icon>
                  <span class="pl-5">{{ $t('btn.printPays') }}</span>
                </v-btn>
              </v-col>
            </fragment>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          md="2"
          class="text-lowercase"
        >
          <span v-if="pos === 0">
            {{ totalF }} {{ $t('lbl.de') }} {{ totalItems }} <span class="text-lower">{{ $t('menu.ctasXP') }}</span>
          </span>
          <span v-if="pos === 1">
            {{ totalFPays }} {{ $t('lbl.de') }} {{ totalItemsPays }}
            <span class="text-lower">{{ $t('menu.paysEmit') }}</span>
          </span>
        </v-col>
      </v-row>
    </v-form>

    <v-divider></v-divider>

    <v-tabs v-model="pos">
      <v-tab>
        <v-badge
          v-if="cantCtasPending > 0"
          color="warning"
          :content="cantCtasPending"
        >
          {{ $t('menu.cuentasXPagar') }}
        </v-badge>
        <fragment v-else>
          {{ $t('menu.cuentasXPagar') }}
        </fragment>
      </v-tab>
      <v-tab>
        <v-badge
          v-if="cantPaysPending > 0"
          color="warning"
          :content="cantPaysPending"
        >
          {{ $t('menu.paysEmit') }}
        </v-badge>
        <fragment v-else>
          {{ $t('menu.paysEmit') }}
        </fragment>
      </v-tab>
    </v-tabs>

    <v-divider></v-divider>

    <v-tabs-items v-model="pos">
      <v-tab-item @click="setPosCotizador(0)">
        <CuentasXPagar
          v-if="ctas.length > 0"
          :user="user"
          :ctas="ctas"
          :states="states"
          :states-ctas="statesCtas"
          :id-pay="idPay"
          :payments="payments"
          @loadAll="initAll()"
        />
      </v-tab-item>
      <v-tab-item @click="setPosCotizador(1)">
        <PaysEmitidos
          v-if="pays.length > 0"
          :user="user"
          :pays="pays"
          :states="states"
          :states-ctas="statesCtas"
          :payments="payments"
          @loadAll="initAll()"
        />
      </v-tab-item>
    </v-tabs-items>

    <v-card-text class="pt-2">
      <v-row>
        <v-col
          lg="12"
          cols="12"
          class="d-flex justify-end"
        >
          <v-pagination
            v-if="pos === 0"
            v-model="pagination.current"
            :length="pagination.total"
            total-visible="5"
            @input="onPageChange"
          ></v-pagination>
          <v-pagination
            v-else-if="pos === 1"
            v-model="paginationPays.current"
            :length="paginationPays.total"
            total-visible="5"
            @input="onPageChange"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-card-text>

    <SidebarDataPays
      v-if="isSidebarDataPaysActive"
      v-model="isSidebarDataPaysActive"
      from="pays"
      :user="user"
      @initAll="initAll"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {
  mdiMagnify,
  mdiDeleteOutline,
  mdiSquareEditOutline,
  mdiPlus,
  mdiArrowLeft,
  mdiUpdate,
  mdiFormatListText,
  mdiAirplaneTakeoff,
  mdiCar,
  mdiBed,
  mdiClose,
  mdiEye,
  mdiEraserVariant,
  mdiAccountCashOutline,
  mdiSendOutline,
  mdiPrinter,
} from '@mdi/js'

// eslint-disable-next-line import/no-unresolved
import PaysEmitidos from '@/views/administration/paysEmitidos/utils/PaysEmitidos.vue'
import SidebarDataPays from '../utils/SidebarDataPays.vue'

// eslint-disable-next-line import/no-unresolved
// import useAppConfig from '@core/@app-config/useAppConfig'

// eslint-disable-next-line import/no-unresolved
import CuentasXPagar from '../utils/CuentasXPagar.vue'

// import Cotizations from '../tabs/Cotizations.vue'

export default {
  /* setup() {
    const { menuIsVerticalNavMini } = useAppConfig()

    return {
      menuIsVerticalNavMini,
    }
  }, */

  components: {
    CuentasXPagar,
    SidebarDataPays,
    PaysEmitidos,
  },

  data() {
    return {
      isSidebarDataPaysActive: false,
      currentTab: 0,
      isLoading: true,
      search: {
        proximas: false,
        activas: false,
        state: null,
        afiliate: null,
      },
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
        wheelSpeed: 0.7,
      },
      ctas: [],
      pagination: {
        current: 1,
        total: 0,
      },
      totalItems: 0,
      totalF: 0,
      pays: [],
      wayPays: [],
      currencies: [],
      importes: [],
      importesList: [],
      importesSearch: null,
      paginationPays: {
        current: 1,
        total: 0,
      },
      totalItemsPays: 0,
      totalFPays: 0,
      itemsPerPage: 10,
      icons: {
        mdiMagnify,
        mdiDeleteOutline,
        mdiSquareEditOutline,
        mdiPlus,
        mdiArrowLeft,
        mdiUpdate,
        mdiFormatListText,
        mdiAirplaneTakeoff,
        mdiCar,
        mdiBed,
        mdiClose,
        mdiEye,
        mdiEraserVariant,
        mdiAccountCashOutline,
        mdiSendOutline,
        mdiPrinter,
      },
      isDialogVisible: false,
      isDialogVisibleDelete: false,
      item: {},
      itemId: null,
      abilities: [],
      abilityList: [],
      states: [],
      statesCtas: [],
      payments: [],
      checkPermiso: 1,
      loading: false,
      loadingPay: false,
      permisos: sessionStorage.getItem('permisos_auth'),
      is_nivel_propietario: false,
      user: {},
      codesList: [],
      codesCtas: [],
      codesPaysList: [],
      codesPays: [],
      searchCodePays: null,
      acredoresList: [],
      acredores: [],
      acredorSearch: null,
      usersEmitidos: [],
      usersEmitidosList: [],
      usersEmitidosSearch: null,
      idPay: -1,
      searchCodeCtas: null,
      proveedoresList: [],
      proveedores: [],
      proveedorSearch: null,
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
      menuFrom: false,
      menuTo: false,
      pos: 0,
    }
  },
  computed: {
    ...mapState({
      itemsCheck: state => state.app.itemsCheck,
      itemsCheckPaysEmit: state => state.app.itemsCheckPaysEmit,
      posCotizador: state => state.app.posCotizador,
    }),
    computedFromDateFormatted() {
      return this.search.from ? this.$moment(this.search.from).format('D-MMM-YY') : ''
    },
    computedToDateFormatted() {
      return this.search.to ? this.$moment(this.search.to).format('D-MMM-YY') : ''
    },

    cantCtasPending() {
      let cant = 0
      this.ctas.forEach(element => {
        if (element.status) {
          if (element.status.slug === 'pendiente') {
            cant += 1
          }
        }
      })

      return cant
    },
    cantPaysPending() {
      let cant = 0
      this.pays.forEach(element => {
        if (element.status) {
          if (element.status.slug === 'pendiente') {
            cant += 1
          }
        }
      })

      return cant
    },
  },
  watch: {
    searchCodeCtas(val) {
      if (val.length > 0) {
        // eslint-disable-next-line no-unused-expressions
        val && this.filterCodesCtas(val.toLowerCase())
      } else {
        this.codesCtas = []
      }
    },

    proveedorSearch(val) {
      if (val.length > 0) {
        // eslint-disable-next-line no-unused-expressions
        val && this.filterProveedor(val.toLowerCase())
      } else {
        this.proveedores = []
      }
    },

    searchCodePays(val) {
      if (val.length > 0) {
        // eslint-disable-next-line no-unused-expressions
        val && this.filterCodesPays(val.toLowerCase())
      } else {
        this.codesPays = []
      }
    },

    acredorSearch(val) {
      if (val.length > 0) {
        // eslint-disable-next-line no-unused-expressions
        val && this.filterAcredor(val.toLowerCase())
      } else {
        this.acredores = []
      }
    },

    importesSearch(val) {
      if (val.length > 0) {
        // eslint-disable-next-line no-unused-expressions
        val && this.filterImportes(val.toLowerCase())
      } else {
        this.importes = []
      }
    },

    usersEmitidosSearch(val) {
      if (val.length > 0) {
        // eslint-disable-next-line no-unused-expressions
        val && this.filterUsersEmitidos(val.toLowerCase())
      } else {
        this.usersEmitidos = []
      }
    },
  },
  mounted() {
    // PARA Q NAZCA EL MENU IZQ OCULTO
    // this.menuIsVerticalNavMini = true
    // this.pos = this.posCotizador
  },
  created() {
    this.profile()
    this.initAll()

    this.getStates()
    this.getStatesCtas()
    this.getPayments()
    this.getProveedores()
    this.getCodes()

    this.getAcredorPays()
    this.getCodesPays()
    this.getUserEmitidoPays()
    this.getImportesPays()

    this.wayPays.push({
      name: this.$t('lbl.transferBank'),
      slug: 'transfer',
    })
    this.wayPays.push({
      name: this.$t('lbl.credit'),
      slug: 'credit',
    })
    this.wayPays.push({
      name: this.$t('lbl.payCard'),
      slug: 'payCard',
    })
    this.wayPays.push({
      name: this.$t('lbl.linkPay'),
      slug: 'linkPay',
    })
    this.wayPays.push({
      name: this.$t('lbl.checkBank'),
      slug: 'checkBank',
    })
    this.wayPays.push({
      name: this.$t('lbl.cash'),
      slug: 'cash',
    })

    this.currencies.push({
      name: 'USD',
      slug: 'USD',
    })
    this.currencies.push({
      name: 'EUR',
      slug: 'EUR',
    })

    // this.getTiposProduct()
    // this.getNamesClient()
    // this.getCodesReservas()
    // this.getSeller()
  },
  methods: {
    ...mapMutations(['setPosCotizador', 'setCheckAll', 'updateItemCheck', 'updateItemCheckPaysEmit']),
    filterProveedor(v) {
      this.proveedores = []
      if (v === '') {
        this.proveedores = []
      } else {
        this.proveedores = this.proveedoresList.filter(e => e.name.toLowerCase())
      }
    },
    filterCodesCtas(v) {
      this.codesCtas = []
      if (v === '') {
        this.codesCtas = []
      } else {
        this.codesCtas = this.codesList.filter(e => e.toLowerCase())
      }
    },

    filterAcredor(v) {
      this.acredores = []
      if (v === '') {
        this.acredores = []
      } else {
        this.acredores = this.acredoresList.filter(e => e.user_name.toLowerCase())
      }
    },
    filterUsersEmitidos(v) {
      this.usersEmitidos = []
      if (v === '') {
        this.usersEmitidos = []
      } else {
        this.usersEmitidos = this.usersEmitidosList.filter(e => e.name.toLowerCase())
      }
    },
    filterCodesPays(v) {
      this.codesPays = []
      if (v === '') {
        this.codesPays = []
      } else {
        this.codesPays = this.codesPaysList.filter(e => e.toLowerCase())
      }
    },
    filterImportes(v) {
      this.importes = []
      if (v === '') {
        this.importes = []
      } else {
        this.importes = this.importesList.filter(e => e)
      }
    },

    profile() {
      this.axios
        .get(`${process.env.VUE_APP_API_URL}profile`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(response => {
          // eslint-disable-next-line no-empty
          if (response.data.success === false) {
          } else if (response.data.data.nivel === -1) {
            this.is_nivel_propietario = true
          }
          this.user = response.data.data
        })
        .catch(error => console.log(error))
        // eslint-disable-next-line no-return-assign
        .finally(() => (this.isLoading = false))
    },
    getStates() {
      this.axios
        .get('state_reservations?per_page=10000', {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          this.states = res.data.data
        })
    },
    getStatesCtas() {
      this.axios
        .get('state_ctas?per_page=10000', {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          this.statesCtas = res.data.data
          this.statesCtas.forEach(element => {
            if (element.slug === 'pagado') {
              this.idPay = element.id
            }
          })
        })
    },
    getPayments() {
      this.axios
        .get('nom_methods_pay?per_page=10000', {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          this.payments = res.data.data
        })
    },
    getProveedores() {
      this.axios
        .post(
          'ctas-x-pagar/search-list',
          {
            parameter: 'proveedor',
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
            },
          },
        )
        .then(res => {
          if (res.data.success) {
            this.proveedoresList = res.data.data.list
          }
        })
    },
    getCodes() {
      this.axios
        .post(
          'ctas-x-pagar/search-list',
          {
            parameter: 'code',
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
            },
          },
        )
        .then(res => {
          if (res.data.success) {
            this.codesList = res.data.data.list
          }
        })
    },

    getCuentas() {
      this.ctas = []
      const json = {
        page: this.pagination.current,
        per_page: this.itemsPerPage,
        search: this.search,
        pay: false,
      }
      this.axios
        .post('ctas-x-pagar/list', json, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          if (res.data.success === false) {
            // this.$toast.error(this.$t('msg.noAutorice'))
            // this.$store.commit('logout')
          } else {
            // console.log(res)

            this.ctas = res.data.data

            this.pagination.current = res.data.meta.current_page
            this.pagination.total = res.data.meta.last_page

            this.totalF = res.data.meta.total
          }
        })
    },
    changeCantItems() {
      if (this.pos === 0) {
        this.getCuentas()
      } else if (this.pos === 1) {
        this.getPays()
      }
    },
    searchAll() {
      this.pagination.current = 1
      this.paginationPays.current = 1
      if (this.pos === 0) {
        this.getCuentas()
      } else if (this.pos === 1) {
        this.getPays()
      }
    },
    getCuentasAll() {
      const json = {
        page: this.pagination.current,
        per_page: 1000,
        search: this.search,
        pay: false,
      }
      this.axios
        .post('ctas-x-pagar/list', json, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          // eslint-disable-next-line no-empty
          if (res.data.success === false) {
          } else {
            this.totalItems = res.data.meta.total
          }
        })
    },

    getAcredorPays() {
      this.axios
        .post(
          'pays-emitidos/search-list',
          {
            parameter: 'acredor',
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
            },
          },
        )
        .then(res => {
          if (res.data.success) {
            this.acredoresList = res.data.data.list
          }
        })
    },
    getCodesPays() {
      this.axios
        .post(
          'pays-emitidos/search-list',
          {
            parameter: 'code',
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
            },
          },
        )
        .then(res => {
          if (res.data.success) {
            this.codesPaysList = res.data.data.list
          }
        })
    },
    getUserEmitidoPays() {
      this.axios
        .post(
          'pays-emitidos/search-list',
          {
            parameter: 'user_emitido',
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
            },
          },
        )
        .then(res => {
          if (res.data.success) {
            this.usersEmitidosList = res.data.data.list
          }
        })
    },
    getImportesPays() {
      this.axios
        .post(
          'pays-emitidos/search-list',
          {
            parameter: 'importe',
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
            },
          },
        )
        .then(res => {
          if (res.data.success) {
            this.importesList = res.data.data.list
          }
        })
    },
    getPays() {
      const json = {
        page: this.paginationPays.current,
        per_page: this.itemsPerPage,
        search: this.search,
      }
      this.axios
        .post('pays-emitidos/list', json, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          if (res.data.success === false) {
            // this.$toast.error(this.$t('msg.noAutorice'))
            // this.$store.commit('logout')
          } else {
            // console.log(res)

            this.pays = res.data.data

            this.paginationPays.current = res.data.meta.current_page
            this.paginationPays.total = res.data.meta.last_page

            this.totalFPays = res.data.meta.total
          }
        })
    },
    getPaysAll() {
      const json = {
        page: this.paginationPays.current,
        per_page: 1000,
        search: this.search,
      }
      this.axios
        .post('pays-emitidos/list', json, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
          },
        })
        .then(res => {
          // eslint-disable-next-line no-empty
          if (res.data.success === false) {
          } else {
            this.totalItemsPays = res.data.meta.total
          }
        })
    },
    onPageChange() {
      if (this.pos === 0) {
        this.getCuentas()
      } else if (this.pos === 1) {
        this.getPays()
      }
    },
    reseat() {
      this.isDialogVisible = false
      this.isDialogVisibleDelete = false
      this.item = {}
      this.itemId = null
      this.loading = false
      this.loadAll()
    },
    loadAll() {
      this.getCuentas()
      this.getPays()
    },
    initAll() {
      this.getCuentas()
      this.getCuentasAll()
      this.getPays()
      this.getPaysAll()
    },

    clearSearch() {
      this.search = {}
      this.loadAll()
    },

    emitPays() {
      let idProv = -1
      let allIdem = true
      this.itemsCheck.forEach(element => {
        /* if (idProv === -1) {
          idProv = element.data_proveedor.company_id
        } else if (idProv !== element.data_proveedor.company_id) {
          allIdem = false
        } */
        if (idProv === -1) {
          idProv = element.company.code_unique
        } else if (idProv !== element.company.code_unique) {
          allIdem = false
        }
      })
      if (allIdem) {
        this.isSidebarDataPaysActive = true
      } else {
        this.$toast.error(this.$t('msg.cxPSameProv'))
        this.setCheckAll(false)
        this.updateItemCheck([])
        this.initAll()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.table-kitchen-sink ::v-deep {
  .v-data-table-header {
    white-space: nowrap;
  }
}
</style>
